module.exports = __webpack_public_path__ + "img/phone-screen-vt.482a3ccf.png";